import React from 'react';
import PropTypes from 'prop-types';
import Business from './Business';
import Users from './Users';
import { Typography } from '@material-ui/core';

function Settings(props) {
  const { business } = props;

  return (
    <>
      <Typography variant='h5' gutterBottom>Details</Typography>
      <Business business={business} />

      <br /><br />

      <Typography variant='h5' gutterBottom>Users</Typography>
      <Users business={business} />
    </>
  );
}

Settings.propTypes = {
  business: PropTypes.object
}

export default Settings;
